// src/components/Instances/views/Licensed/request/request.ts
import { AxiosInstance, AxiosResponse } from 'axios'

export function fetchUnlicensedInstances(api: AxiosInstance): Promise<AxiosResponse> {
    return api.get('/ctxr/-1/listUnlicensed?tenantId=1')
}

export function deleteLicensedInstance(api: AxiosInstance, instanceId: string): Promise<AxiosResponse> {
    return api.delete(`/ctxr/-1/${instanceId}?tenantId=1`)
}
